<template>
  <div class="navbar-nav mr-2 ml-2">
    <AuthenticationButton />
  </div>
</template>

<script>
import AuthenticationButton from '@/components/Auth0/AuthenticationButton'

export default {
  name: 'AuthNav',
  components: { AuthenticationButton },
}
</script>
